import { createApiCaller } from './util'

export const callApi = createApiCaller('finance')
export const callApiLg = createApiCaller('financeLg')

export const callTalousApi = createApiCaller('viiluTalousProxy')
